import React from 'react'
// import './index.scss'

const ConfirmRemoval = (props) => {
    const { remove, cancel, type, userData } = props
    const handleParentClick = (e) => {
        e.stopPropagation();
    }

    return (
        <div className='confirm-removal-container-two' onClick={cancel}>
            <div class='alert-box-container' onClick={handleParentClick}>
                <div className='alert-center'>
                    {/* <p style={{ fontSize: '15px', fontWeight: 'bold', textAlign: 'center' }}>{`Remove this ${type}`}</p> */}
                    <p style={{ fontSize: '18px', margin: '20px 20px 0px 20px', fontWeight: 'bold', textAlign: 'center', lineHeight: 1.5 }}>{`Are you sure you want to unfollow`}</p>
                    <h3 style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center', lineHeight: 1.5, color: 'white' }}>{userData.fullName}</h3>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                        <button
                            onClick={cancel}
                            style={{ margin: '0', width: '45%' }}>CANCEL</button>
                        <button
                            onClick={remove}
                            style={{ margin: '0', backgroundColor: '#ff6800', width: '45%' }}>YES, Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfirmRemoval